// extracted by mini-css-extract-plugin
module.exports = {"faq-navigation":"navigation_faq-navigation__TMcPs","active-card":"navigation_active-card__rWFiV","bottom-btn":"navigation_bottom-btn__IGI_z"};